import { render, staticRenderFns } from "./DataCard.vue?vue&type=template&id=2e83bf70&scoped=true"
import script from "./DataCard.vue?vue&type=script&lang=js"
export * from "./DataCard.vue?vue&type=script&lang=js"
import style0 from "./DataCard.vue?vue&type=style&index=0&id=2e83bf70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e83bf70",
  null
  
)

export default component.exports